import axios from 'axios';
import { getUser } from './authManager';

const api = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}/api`,
});

api.interceptors.request.use(
  (config) => {
    const user = getUser();
    if (user && user.access_token) {
      config.headers.Authorization = `Bearer ${user.access_token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export const fetchRadiologicalImpressions = () => {
  return api.get('/radiological-impressions');
};

export default api;